export default function CheckIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" fill="none" viewBox="0 0 14 10">
            <path fill="#fff" d="M4.8 9.8.2 5.4a.7.7 0 0 1 0-.9l1-1a1 1 0 0 1 1 0l3 3L11.8.2c.3-.3.7-.3 1 0l1 1c.3.2.3.6 0 .9l-8 7.7c-.3.3-.8.3-1 0Z"/>
        </svg>
    )
}